module.exports = __webpack_public_path__ + "static/media/21ECLAC17.6afad46c.jpg";